import { WarningOutlined } from "@ant-design/icons";
import React, { ReactNode } from 'react';
import Footer from "../../../Popup/_components/Footer";
import Header from "../../../Popup/_components/Header";
import styles from "./style.module.scss";

interface IProps {
    isComplete: boolean
    name?: ReactNode
    message?: string

    onOk(): void

    onClose?(): void
}

const ConfirmNextState: React.FC<IProps> = ({ isComplete, name, message, onOk, onClose }) => {
    const handleOk = () => {
        onOk();
        onClose?.()
    }

    return <div>
        <Header title={<span className='font-s2'>Warning</span>} onClose={() => onClose?.()} />
        <div className='flex items-center px-3 mt-2'>
            <WarningOutlined className={styles.iconWarn} />
            <span className='ml-2'>
                {message || <>Do you want to {isComplete ? 'complete the operation' : name}?</>}
            </span>
        </div>
        <Footer ok={{ click: handleOk, text: 'Ok' }} cancel={{ click: onClose }} />
    </div>;
};

export default ConfirmNextState;
